import { createReducer } from "../../../_common/common";
import { SET_MAD_CERT_APPLICATION_STATUS} from "../actions/constants";

const initialState = {
    status: null,
}
export const madCertificateApplication = createReducer(initialState, {
    [SET_MAD_CERT_APPLICATION_STATUS]: (state, payload) => {
        state.status = payload;
        return state
    }
});
